"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiService = void 0;
class MultiService {
    constructor(_services) {
        this._services = _services;
    }
    get isRunning() {
        return this._services.map(x => x.isRunning).every(x => x);
    }
    async start() {
        await Promise.all(this._services.map(x => x.start()));
    }
    async stop() {
        await Promise.all(this._services.map(x => x.stop()));
    }
    async waitUntilStopped() {
        await Promise.all(this._services.map(x => x.waitUntilStopped()));
    }
}
exports.MultiService = MultiService;
//# sourceMappingURL=multi-service.js.map